<template>
    <div class="modal-overlay">
        <div class="modal-box small y-devir modal">
            <span class="close" @click="closeDevir()">&times;</span>
            <h3>{{ selectedPatient.name }}</h3>
            <form v-on:submit.prevent>
                <div class="modal-overlay" v-if="tedavi.mode != 0">
                    <div class="modal-box small">
                        <span class="close" @click="closeTedavi()">
                            &times;
                        </span>
                        <h3>
                            {{ tedavi.mode == 1 ? "Yeni Tedavi" : "Düzenle" }}
                        </h3>
                        <form v-on:submit.prevent>
                            <div class="labeledit">
                                <label>Gün Takibi</label>
                                <div class="toggle-group">
                                    <label for="p-gun-1">
                                        <input
                                            id="p-gun-1"
                                            class="modern"
                                            type="radio"
                                            value="1"
                                            v-model="tedavi.veri.gun"
                                        />
                                        <span>Evet</span>
                                    </label>

                                    <label for="p-gun-2">
                                        <input
                                            id="p-gun-2"
                                            class="modern"
                                            type="radio"
                                            value="2"
                                            v-model="tedavi.veri.gun"
                                        />
                                        <span>Hayır</span>
                                    </label>
                                </div>
                            </div>
                            <div class="labeledit">
                                <label for="p-baslama">Başlama Tarihi</label>
                                <input
                                    type="date"
                                    v-model="tedavi.veri.tarih"
                                    id="p-baslama"
                                />
                            </div>
                            <div class="labeledit">
                                <label for="p-tdv">Tedavi ve Doz</label>
                                <div class="multi-input">
                                    <input
                                        type="text"
                                        placeholder="Tedavi"
                                        v-model="tedavi.veri.tedavi"
                                        id="p-tdv"
                                    />
                                    <div class="space"></div>
                                    <input
                                        type="text"
                                        placeholder="Doz"
                                        v-model="tedavi.veri.doz"
                                        id="p-doz"
                                    />
                                </div>
                            </div>
                        </form>
                        <div class="button-bar">
                            <a
                                class="btn btn-red fl"
                                v-show="tedavi.mode == 2"
                                @click.prevent="stopTedavi()"
                            >
                                <i class="fa fa fa-ban"></i>
                                Stopla
                            </a>
                            <a
                                class="btn link-green fr"
                                @click.prevent="saveTedavi()"
                            >
                                <i class="fa fa fa-check"></i>
                                Kaydet
                            </a>
                            <div class="clear"></div>
                        </div>
                    </div>
                </div>
                <div class="y-devir boxed">
                    <div class="rop-alert" v-show="selectedPatient.dhafta < 34">
                        <div class="title blink">ROP</div>
                        <div class="detail">
                            Bu hastanın ROP muayenesi için yakın takibi
                            gereklidir
                        </div>
                    </div>
                    <div class="devir-bar">
                        <div class="fr">
                            KŞ :
                            <select v-model="selectedPatient.ks">
                                <option value="0">-</option>
                                <option value="1">x1</option>
                                <option value="2">x2</option>
                                <option value="4">x4</option>
                                <option value="6">x6</option>
                                <option value="8">x8</option>
                            </select>
                            TCB :
                            <select v-model="selectedPatient.tcb">
                                <option value="0">-</option>
                                <option value="1">x1</option>
                                <option value="2">x2</option>
                                <option value="4">x4</option>
                                <option value="6">x6</option>
                            </select>
                            TARTI :
                            <select v-model="selectedPatient.tarti">
                                <option value="1">x1</option>
                                <option value="2">x2</option>
                                <option value="3">x3</option>
                            </select>
                        </div>
                        <div class="clear"></div>
                    </div>
                    <div class="content">
                        <p>
                            <input
                                type="text"
                                v-model="selectedPatient.tanilar"
                                id="p-tani"
                                placeholder="Tanılar"
                            />
                        </p>
                        <p>
                            YATIŞININ
                            <b>{{ selectedPatient.yatis | toGun }}Ü</b>
                            ,
                            <template
                                v-if="
                                    selectedPatient.birthdate !=
                                    selectedPatient.yatis
                                "
                            ></template>
                            D.YAŞI :
                            <b>{{ dyas }}</b>
                            , D.TARTISI :
                            <b>{{ selectedPatient.dtarti }}</b>
                            gr
                        </p>
                    </div>
                    <div class="labeledit">
                        <div class="toggle-group rbtn">
                            <label for="p-solunum-1">
                                <input
                                    id="p-solunum-1"
                                    class="modern"
                                    type="radio"
                                    value="1"
                                    name="solunum"
                                    v-model="selectedPatient.takip_solunum"
                                />
                                <span>ODA HAVASI</span>
                            </label>

                            <label for="p-solunum-2">
                                <input
                                    id="p-solunum-2"
                                    class="modern"
                                    type="radio"
                                    value="2"
                                    name="solunum"
                                    v-model="selectedPatient.takip_solunum"
                                />
                                <span>SERBEST O2</span>
                            </label>
                            <label for="p-solunum-3">
                                <input
                                    id="p-solunum-3"
                                    class="modern"
                                    type="radio"
                                    value="3"
                                    name="solunum"
                                    v-model="selectedPatient.takip_solunum"
                                />
                                <span>nCPAP</span>
                            </label>
                            <label for="p-solunum-4">
                                <input
                                    id="p-solunum-4"
                                    class="modern"
                                    type="radio"
                                    value="4"
                                    name="solunum"
                                    v-model="selectedPatient.takip_solunum"
                                />
                                <span>ENTÜBE</span>
                            </label>
                        </div>
                    </div>
                    <div class="devir-box">
                        <p>
                            <b>BESLENME,TPN VE MAYİ</b>
                        </p>
                        <div>
                            <textarea-autosize
                                spellcheck="false"
                                id="p-parenteral"
                                v-model="selectedPatient.takip_beslenme"
                                placeholder="Beslenme ve Tetkikler"
                            />
                        </div>
                    </div>

                    <div class="tedaviler">
                        <div class="info-header">
                            <span class="title">TEDAVİLER</span>
                            <a
                                class="btn link-green fr"
                                @click.prevent="addTedavi()"
                            >
                                <i class="fa fa fa-plus"></i>
                                Ekle
                            </a>
                        </div>
                        <div
                            v-if="!selectedPatient.tedavi.length"
                            class="small-empty"
                        >
                            <i class="fa fa-exclamation-triangle fa-3x"></i>
                            <span>Henüz tedavi başlanmadı</span>
                        </div>
                        <ul v-if="selectedPatient.tedavi.length">
                            <li
                                v-for="t in selectedPatient.tedavi"
                                :key="t.id"
                                @click="editTedavi(t.id)"
                            >
                                {{ t.tedavi }}
                                {{ t.doz != "" ? "(" + t.doz + ")" : "" }}
                                <b>{{ (t.gun == 1 ? t.tarih : "") | toGun }}</b>
                            </li>
                        </ul>
                    </div>
                    <div class="devir-box">
                        <p>
                            <b>ROP, EKO VE USG TAKİPLERİ</b>
                        </p>
                        <div>
                            <textarea-autosize
                                spellcheck="false"
                                placeholder="ROP, EKO VE USG Takipleri"
                                v-model="selectedPatient.plan2"
                                rows="6"
                            />
                        </div>
                    </div>
                    <div class="devir-box">
                        <p>
                            <b>TAKİPLER VE PLAN</b>
                        </p>
                        <div>
                            <textarea-autosize
                                spellcheck="false"
                                placeholder="Takipler ve Plan"
                                v-model="selectedPatient.plan"
                                rows="6"
                            />
                        </div>
                    </div>
                </div>
            </form>
            <div class="button-bar">
                <a
                    class="btn btn-blue fl"
                    @click.prevent="
                        $router.push('/patients/' + path + selectedPatient.id)
                    "
                >
                    <i class="fa fa fa-angle-right"></i>
                    Hastaya Git
                </a>
                <a class="btn link-green fr" @click.prevent="saveDevir()">
                    <i class="fa fa fa-save"></i>
                    Kaydet
                </a>
                <div class="clear"></div>
            </div>
        </div>
    </div>
</template>

<script>
import qs from "qs";
export default {
    name: "DevirModalYD",
    props: {
        selectedPatient: {},
        path: String,
    },
    data() {
        return {
            tedavi: {
                mode: 0,
                veri: {},
            },
        };
    },
    computed: {
        dyas() {
            var r =
                this.gunFarkiDay(this.selectedPatient.birthdate, new Date()) -
                1;

            var h = Math.floor(r / 7);
            var g = parseInt(this.selectedPatient.dgun);
            var dh, dg;

            if (r - h * 7 + g < 7) {
                dh = parseInt(this.selectedPatient.dhafta) + h;
                dg = r - h * 7 + g;
            } else {
                dh = parseInt(this.selectedPatient.dhafta) + h + 1;
                dg = r - h * 7 + g - 7;
            }
            return dh + "w" + (dg > 0 ? "+" + dg + "d" : "");
        },
    },
    methods: {
        saveDevir() {
            this.$emit("save");
        },
        closeDevir() {
            this.$emit("close");
        },
        gunFarkiDay(b1, b2) {
            var days = this.$moment(b2).diff(this.$moment(b1), "days", true);
            return Math.ceil(days);
        },

        closeTedavi() {
            this.tedavi.mode = 0;
            this.getTedavi(this.selectedPatient.id);
        },
        addTedavi() {
            this.tedavi.mode = 1;
            this.tedavi.veri = {
                q: "add",
                gun: 2,
                tedavi: "",
                doz: "",
                hasta: this.selectedPatient.id,
                tarih: this.$moment(new Date()).format("YYYY-MM-DD"),
            };
        },
        editTedavi(id) {
            this.tedavi.mode = 2;
            this.tedavi.veri = this.selectedPatient.tedavi.find(
                (t) => t.id === id
            );
            this.tedavi.veri.q = "edit";
        },
        stopTedavi() {
            let self = this;
            this.$http({
                method: "post",
                url: "api/yenidogan/tedavi.php",
                data: qs.stringify({
                    id: this.tedavi.veri.id,
                    q: "stop",
                }),
            }).then(() => {
                self.$snotify.success("Tedavi başarıyla stoplandı");
                self.tedavi.mode = 0;
                self.getTedavi(this.selectedPatient.id);
            });
        },
        saveTedavi() {
            this.$http({
                method: "post",
                url: "api/yenidogan/tedavi.php",
                data: qs.stringify(this.tedavi.veri),
            }).then(() => {
                this.$snotify.success("Tedavi başarıyla kaydedildi");
                this.tedavi.mode = 0;
                this.getTedavi(this.selectedPatient.id);
            });
        },
        getTedavi() {
            this.$http({
                method: "post",
                url: "api/yenidogan/tedavi.php",
                data: qs.stringify({
                    id: this.selectedPatient.id,
                    q: "get",
                }),
            }).then((response) => {
                this.selectedPatient.tedavi = response.data.data.tedavi;
            });
        },
    },
};
</script>

<style>
</style>